export const API_ADMIN_GET_ALL_GENERALPARAMETER = 'API_ADMIN_GET_ALL_GENERALPARAMETER';
export const API_ADMIN_GET_ALL_GENERALPARAMETER_SUCCESS = 'API_ADMIN_GET_ALL_GENERALPARAMETER_SUCCESS';
export const API_ADMIN_GET_ALL_GENERALPARAMETER_FAIL = 'API_ADMIN_GET_ALL_GENERALPARAMETER_FAIL';

export const API_ADMIN_PATCH_GENERALPARAMETER = 'API_ADMIN_PATCH_GENERALPARAMETER';
export const API_ADMIN_PATCH_GENERALPARAMETER_SUCCESS = 'API_ADMIN_PATCH_GENERALPARAMETER_SUCCESS';
export const API_ADMIN_PATCH_GENERALPARAMETER_FAIL = 'API_ADMIN_PATCH_GENERALPARAMETER_FAIL';

export const API_GET_ALL_GENERALPARAMETER = 'API_GET_ALL_GENERALPARAMETER';
export const API_GET_ALL_GENERALPARAMETER_SUCCESS = 'API_GET_ALL_GENERALPARAMETER_SUCCESS';
export const API_GET_ALL_GENERALPARAMETER_FAIL = 'API_GET_ALL_GENERALPARAMETER_FAIL';



